export default __webpack_public_path__ + "static/media/ls2_g01.1bb35596.png";